import {apiFetch} from "../../actions/apiActions";
import {toast} from "react-toastify";
import {setToolsCountryList, setToolsUsersList} from "./toolsActions";

export function getResponsibleUser(){
    return async (dispatch) => {
        try {
            let resp = await dispatch(
                apiFetch("/api/tools/responsible/all", {
                    method: "GET"
                })
            );
            let data = await resp.json();
            if (resp.status !== 200) {
                throw new Error(data.message);
            }
            dispatch(setToolsUsersList(data.usersData));
            return data;
        } catch (e) {
            toast(e.message, {type: 'error'});
        }
    }
}